/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPtTicketDataResponse as AgentApiContractGetPtTicketDataResponse } from '../../models/AgentApi/Contract/get-pt-ticket-data-response';

export interface ApiAgentGetPtTicketDataGet$Params {

/**
 * * Interface language
 */
  lang?: string;

/**
 * * terminal id
 */
  termCode?: string;

/**
 * * ticket series
 */
  series?: string;

/**
 * * ticket number
 */
  num?: string;
}

export function apiAgentGetPtTicketDataGet(http: HttpClient, rootUrl: string, params?: ApiAgentGetPtTicketDataGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractGetPtTicketDataResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAgentGetPtTicketDataGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('termCode', params.termCode, {});
    rb.query('series', params.series, {});
    rb.query('num', params.num, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractGetPtTicketDataResponse>;
    })
  );
}

apiAgentGetPtTicketDataGet.PATH = '/api/Agent/GetPtTicketData';
